// extracted by mini-css-extract-plugin
export default {"block":"ourtarif_block__3O2F2","list":"ourtarif_list__VXW-8"};